import { Injectable, NgZone } from '@angular/core';
import { Subject } from "rxjs/Subject";

@Injectable()
export class EventService {
    // If eventService is to be used, create an array of listeners on component.
    // The value returned by each "on" statement should be pushed onto said array.
    // Have an ngOnDestroy property that calls unsubscribe with the listeners array.
    // That way, when a listening component is destroyed, the listener itself is also destroyed.
    // Prevents Memory Leak  



    //*************** Global Events ********************
    _noLogin: string = "No Login";
    _reloadUsersGrid: string = "Reload Users Grid";
    _displayModal: string = "Display Modal";
    _showSpinner: string = "Show Spinner";
    _closeSpinner: string = "Close Spinner";
    _openAccountInfo: string = "Open Account Information";
    _openUserManagement: string = "Open User Management";
    _openPermissionsManagement: string = "Open Permissions Management";
    _focusBigButton: string = "Focus Big Button";
    _accessTokenAzure: string = "Access Token Azure";
    _signInWithSSO: string = "Sign in with SSO";
    _loginWithSSO: string = "Login with SSO";
    _registerSSO: string = "Register SSO";
    _silentLogout: string = "Silent Logout";
    _goToPage: string = "Go To Page";

    //**************************************************


    listeners: any;
    eventsSubject: any;
    events: any;
    constructor(
        private ngZone: NgZone
    ) {
        this.listeners = {};
        this.eventsSubject = new Subject<any>();
        this.events = this.eventsSubject.asObservable();

        this.events.subscribe(({ name, args }) => {
            if (this.listeners[name]) {
                for (let listener of this.listeners[name]) {
                    listener(...args);
                }
            }
        });
    }

    on(name, listener) {
        if (!this.listeners[name]) {
            this.listeners[name] = [];
        }
        listener.id = this.listeners[name].length;
        listener.index = name;
        this.listeners[name].push(listener);
        return listener;
    }

    broadcast(name, ...args) {
        this.eventsSubject.next({
            name,
            args
        });
    }



    unsubscribe(listeners) {
        for (var i = 0; i < listeners.length; i++) {
            var array = this.listeners[listeners[i].index];
            for (var j = 0; j < array.length; j++) {
                if (listeners[i].id == array[j].id) {
                    array.splice(j, 1);
                    break;
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Services/event.service.ts